/**
 * Verbs: translations plus the conjugation, where the source printed one.
 *
 * The forms are free data from the A2/B1 Wortlisten, which print
 * "abholen, holt ab, holte ab, hat abgeholt" next to the infinitive. The block
 * is omitted entirely for verbs whose list gave only the bare infinitive —
 * an empty three-column table would just look broken.
 */
import { TranslationCardBack } from '@/components/practice/TypeTranslationCard';
import type { VerbPayload } from '@/core/types';

import type { CardBackProps } from '../types';

export function CardBack(props: CardBackProps<VerbPayload>) {
  const { card } = props;
  return (
    <TranslationCardBack
      {...props}
      nextLabel="Next verb"
      headword={
        <>
          {card.payload.reflexive && <span className="text-muted-foreground">sich </span>}
          {card.de}
        </>
      }
      detail={<Conjugation payload={card.payload} />}
    />
  );
}

/** The three principal parts, where the source printed them. */
function Conjugation({ payload }: { payload: VerbPayload }) {
  const forms: [string, string | null][] = [
    ['er/sie', payload.present_3sg],
    ['Präteritum', payload.praeteritum],
    ['Perfekt', payload.perfekt],
  ];
  const present = forms.filter(([, v]) => v);
  if (present.length === 0) return null;
  return (
    <dl className="bg-muted/40 flex flex-wrap gap-x-6 gap-y-1 rounded-md p-3 text-sm">
      {present.map(([label, value]) => (
        <div key={label} className="flex items-baseline gap-2">
          <dt className="text-muted-foreground text-xs tracking-wide uppercase">{label}</dt>
          <dd className="font-medium">{value}</dd>
        </div>
      ))}
    </dl>
  );
}
